import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";

export const getUserWalletService = () => {
  return privateRequest.get(`${ConfEnv.API_WALLET.URL_WALLET}`);
};
